// extracted by mini-css-extract-plugin
export default {"heading":"pu-z","corrected":"qu-z","redirectVerbiageContainer":"ru-z","redirectVerbiageText":"su-z"};